// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAppAttestChallengeIssueBody = {
  purpose: "attestation" | "assertion";
};

export type typeAppAttestChallengeIssueOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    isRequired: boolean;
    challengeId: string | null;
    challenge: string | null;
  };
};

export type typeAppAttestChallengeIssueOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAppAttestChallengeIssueOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAppAttestChallengeIssueBody = {
  type: "object",
  properties: {
    purpose: { type: "string", enum: ["attestation", "assertion"] },
  },
  required: ["purpose"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAppAttestChallengeIssue(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAppAttestChallengeIssueBody);
  }

  return async function postAppAttestChallengeIssue(
    payload: typeAppAttestChallengeIssueBody,
  ): Promise<
    typeAppAttestChallengeIssueOutput200 | typeAppAttestChallengeIssueOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAppAttestChallengeIssue" failed before calling the network. #d96eef078701`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d96eef078701" },
        },
        data: null,
      } as typeAppAttestChallengeIssueOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/app-attest/challenge-issue`,
      httpMethod: "POST",
      options,
    })) as
      | typeAppAttestChallengeIssueOutput200
      | typeAppAttestChallengeIssueOutput400;
  };
}
